<template>
  <div class="container">
    <img class="bg" src="https://jc-1300322797.cos.ap-shanghai.myqcloud.com/static/extra/img/2022-scan-first-half-bg.png"
      alt="">
    <div class="scan" @click="scanCode()">
      <img src="../../../assets/images/activity/fragment/2021scan.png" alt="">
    </div>

    <quality-assurance-tray-info v-show="showTrayInfoPop" :trayInfo="trayInfo"
      :showTrayInfo="showTrayInfo"></quality-assurance-tray-info>
    <popUpDisplay :show.sync="popUpDisplay.dialog" :activityPrize="popUpDisplay.activityPrize" :type="popUpDisplay.type">
    </popUpDisplay>
    <ActivityCollectCardsGet ref="ActivityCollectCardsGet" :getPieceList="getPieceList"
      :bonusPointValue="bonusPointValue"></ActivityCollectCardsGet>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import { Dialog } from 'vant'
import activityApi from '@/api/activity'
import qualityAssuranceTrayInfo from './components/quality-assurance-tray-info.vue'
import ActivityCollectCardsGet from '@/views/activity/2023/components/activity-collectCards-get.vue'
import popUpDisplay from '../../../components/popup-cards.vue'
import { scanCode } from '@/utils/carzoneapp'
export default {
  components: {
    qualityAssuranceTrayInfo,
    popUpDisplay,
    ActivityCollectCardsGet
  },
  name: 'scanFirstHalf',

  data () {
    return {
      dialog: false,
      trayInfo: {},
      showTrayInfoPop: false,
      showTrayInfo: true,
      popUpDisplay: {
        dialog: false,
        activityPrize: {},
        type: 'scan'
      },
      getPieceList: [],
      bonusPointValue: 0
    }
  },
  created () {
    this.clientInfo = userUtils.getClientInfo() || ''
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })
  },
  mounted () {
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log('isIOS', isIOS)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
    if (Object.keys(this.clientInfo).length !== 0) {
      let channelPrefix = (this.clientInfo.channelCode && this.clientInfo.channelCode.substring(0, 2)) || ''
      if (this.clientInfo.marketName !== 'IAM') {
        this.$dialog.alert({
          message: '此功能仅向AA用户开放'
        }).then(() => {
          document.location = process.env.VUE_APP_EXTRA_SITE + '/#/tab/home'
        })
      } else if (channelPrefix !== '13') {
        // 修理厂渠道扫码停留在当前页面
        if (this.clientInfo.channelCode === '1220') {
          // 1220 GSP用户扫码功能入口
          this.$router.push({ name: 'plain-qrCode-scan' })
        } else {
          this.$dialog.alert({
            message: '该功能尚未开放'
          }).then(() => {
            document.location = process.env.VUE_APP_EXTRA_SITE + '/#/tab/home'
          })
        }
      }
    }
  },
  methods: {
    // 扫码
    scanCode () {
      if (!this.clientInfo) {
        Dialog.alert({
          title: '提示',
          message: '您当前尚未登陆，请前往登录页面登录'
        }).then(() => {
          this.$router.push({ name: 'login2', params: { redirectUrl: this.$route.name } })
        })
      } else {
        var u = navigator.userAgent
        // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
        // let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
        let isCZ = u.match(/czbu/i)
        if (isCZ) {
          // 康众扫码
          scanCode().then(res => {
            this.scanResult({
              scanCode: res
            })
          }).catch(res => {
            this.$toast('调用扫码功能异常')
            console.log('err', res)
          })
        } else {
          this.$wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
            success: res => {
              let scanData = {
                scanCode: res.resultStr
              }
              this.getLocation(scanData)
            },
            fail: res => {
              this.$toast('调用扫码功能异常')
              console.log('fail', res)
            },
            cancel: function () {
              console.log('scan cancel')
            }
          })
        }
      }
    },

    // 获取经纬度
    getLocation (scanData) {
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          scanData.locLat = res.latitude // 纬度，浮点数，范围为90 ~ -90
          scanData.locLong = res.longitude // 经度，浮点数，范围为180 ~ -180。
          this.scanResult(scanData)
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },

    // 扫码结果
    scanResult (value) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi.scanFirstHalf2022(value).then(res => {
        this.$toast.clear()
        console.log(res)
        if (res.data.resultCode === '0') {
          const { getPieceList, scanInfo } = res.data.resultData
          this.bonusPointValue = (scanInfo && scanInfo.bonusPointValue) || 0
          if (res.data.resultData.martTrayInfo) {
            this.trayInfo = res.data.resultData.martTrayInfo
            this.showTrayInfoPop = true
          } else if (getPieceList && getPieceList.length) {
            this.getPieceList = getPieceList
            this.$refs['ActivityCollectCardsGet'].open()
          } else {
            if (this.bonusPointValue !== 0) {
              let text = `扫码成功,恭喜你获得${this.bonusPointValue}易加积分`
              Dialog.confirm({
                title: '扫码成功',
                message: text,
                showCancelButton: false
              })
            } else {
              Dialog.confirm({
                title: '扫码成功',
                message: '扫码积分次数已达当年上限，若有疑问请联系博世销售或客服',
                showCancelButton: false
              })
            }
            if (res.data.resultData.activityPrize) {
              this.popUpDisplay.dialog = true
              this.popUpDisplay.activityPrize = res.data.resultData.activityPrize
            }
          }
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100vh;
  background-color: black;
  position: relative;
}

.bg {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  align-items: center;
}

.activity-text {
  width: 100%;
  position: absolute;
  top: 55%;
  text-align: center;

  img {
    width: 220px;
  }
}

.scan {
  width: 100%;
  position: absolute;
  top: 70%;
  text-align: center;

  img {
    width: 160px;
  }
}</style>
